package ui.app.rss.channel


import androidx.compose.material3.SnackbarDuration
import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import io.Repository
import kotlinx.coroutines.launch
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.err_create_fail_campaign
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.log.logERROR
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.await
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal

@VM
class AppRssListingChannelVM : NavigationViewModel() {


    val searchFiled = mutableStateOf(TextFieldValue(""))

    private lateinit var scopeUi: AppRssListingChannelScope

    var state by mutableDataState<AppRssListingChannelScope.Wrapper>()
        private set

    sealed interface Action {
        class New(val item: common.frontend.api.Io.ListingRssChannel.Item) : Action
        class Edit(val item: common.frontend.api.Io.ListingRssChannel.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: AppRssListingChannelVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is New -> vm.channelNew(act.item)
                            is Edit -> vm.channelEdit(act.item)
                        }
                    }
                }
            }
        }
    }

    private fun channelEdit(item: common.frontend.api.Io.ListingRssChannel.Item) {
        scope.launch {
            runCatching {
                Repository.api.rss.channelEdit(item)
            }.onFailure {
                logERROR(it.printStackTrace())
                snackBarStateGlobal.showSnackbar(
                    duration = SnackbarDuration.Long,
                    withDismissAction = true,
                    message = it.message ?: Res.string.err_create_fail_campaign.await()
                )
            }.onSuccess {
                state.entry?.apply {
                    removeAll { it.key == item.id.toString() }
                    add(item)
                }
            }
        }
    }

    private fun channelNew(item: common.frontend.api.Io.ListingRssChannel.Item) {
        scope.launch {
            runCatching {
                Repository.api.rss.channelCreate(item)
            }.onFailure {
                logERROR(it.printStackTrace())
                snackBarStateGlobal.showSnackbar(
                    duration = SnackbarDuration.Long,
                    withDismissAction = true,
                    message = it.message ?: Res.string.err_create_fail_campaign.await()
                )
            }.onSuccess { new ->
                state.entry?.apply {
                    add(new)
                }
            }
        }
    }

    fun init(scopeUi: AppRssListingChannelScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                state = DataState.Result(
                    AppRssListingChannelScope.Wrapper(
                        Repository.api.rss.listingChannel()
                    )
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
